import { module } from 'stereomodularjs';
import Vue from 'vue';
import { compileToFunctions } from 'vue-template-compiler';
import axios from 'axios';
import CardSVG from '../Vue/card.vue';
import { gsap } from "gsap";
import { Draggable } from "gsap/Draggable";


export default class extends module {
    constructor(m) {
        super(m);
    }

    async init() {
        const template = this.el.nextElementSibling;
        let defaultSeason = this.el.dataset.season;
        template.remove();
        this.initVUE(template, defaultSeason);
    }

    initVUE(template, defaultSeason){
        Vue.config.devtools = true;
        Vue.config.productionTip = false;
        //Cast template as string
        template = template.innerHTML;
        const res = compileToFunctions(template);
        const app = new Vue({
            el: this.el,
            components: {
              'card-svg': CardSVG,
            },
            ...res,
            data: {
                attractions: {},
                season: defaultSeason,
                categoriesSelected: [],
                attractionsSelected: [],
                currentTab: 'attractions',
                isDown: false,
                startX: 0,
                scrollLeft: 0,
            },
            methods: {
                async fetchAttractions() {
                    //fecth data with axios
                    await axios.get('/wp-json/attractions/v1/fetch?'+Math.random().toString(36).substring(2,7))
                    .then(response => {
                        this.attractions = response.data;
                        return response.data;
                    })
                },
                isEmpty(obj) {
                    for(var key in obj) {
                        if(obj.hasOwnProperty(key))
                            return false;
                    }
                    return true;
                },
                currentSeasonId() {
                    let array = Object.values(this.attractions);
                    return array[array.findIndex(season => season.slug === this.season)].term_id;
                },
                isChecked(id, array) {
                  return array.includes(id);
                },
                updateCats(id) {
                  if(this.categoriesSelected.includes(id)){
                    this.categoriesSelected = this.categoriesSelected.filter(cat => cat !== id);
                  }else{
                    this.categoriesSelected.push(id);
                  }
                  let array = Object.values(this.attractions);
                  let attractions = Object.values(array[array.findIndex(season => season.slug === this.season)].categories);
                  let categories = attractions.filter(cat => this.categoriesSelected.includes(cat.term_id));
                },
                updateAttractions(id) {
                    if(this.attractionsSelected.includes(id)){
                        this.attractionsSelected = this.attractionsSelected.filter(attraction => attraction !== id);
                    }else{
                        this.attractionsSelected.push(id);
                    }
                    let array = Object.values(this.attractions);
                    let attractions = Object.values(array[array.findIndex(season => season.slug === this.season)].categories);
                    let attractionsSelected = [];
                    attractions.forEach(cat => {
                        attractionsSelected = attractionsSelected.concat(cat.attractions.filter(attraction => this.attractionsSelected.includes(attraction.ID)));
                    });
                },
            },
            watch: {
              season: function (val) {
                let array = Object.values(this.attractions);
                let categories = Object.values(array[array.findIndex(season => season.slug === val)].categories);
                let categoriesSelected = categories.map(cat => cat.term_id);
                this.categoriesSelected = categoriesSelected;
              },
              currentTab: function (val) {
                if(val === 'attractions'){
                  //Unselect all attractions
                  this.attractionsSelected = [];
                  //Select all categories
                  let array = Object.values(this.attractions);
                  let categories = Object.values(array[array.findIndex(season => season.slug === this.season)].categories);
                  let categoriesSelected = categories.map(cat => cat.term_id);
                  this.categoriesSelected = categoriesSelected;
                }else{
                  //Unselect all categories
                  this.categoriesSelected = [];
                  //Select all attractions
                  let array = Object.values(this.attractions);
                  let attractions = Object.values(array[array.findIndex(season => season.slug === this.season)].categories);
                  let attractionsSelected = [];
                  attractions.forEach(cat => {
                      attractionsSelected = attractionsSelected.concat(cat.attractions.map(attraction => attraction.ID));
                  });
                  this.attractionsSelected = attractionsSelected;
                }
              }
            },
            async mounted() {
                await this.fetchAttractions();

                //Set all categories as selected
                let array = Object.values(this.attractions);
                let categories = Object.values(array[array.findIndex(season => season.slug === this.season)].categories);
                let categoriesSelected = categories.map(cat => cat.term_id);
                this.categoriesSelected = categoriesSelected;

                gsap.registerPlugin(Draggable);

                //set bounds for draggable container o-map-interactive__map
                


                let bigDraggable = Draggable.create("#draggableObject", {
                    type: "x,y",
                    edgeResistance: 0.65,
                    bounds: "#draggableContainer",
                    inertia: true,
                    throwProps:true,
                });

                //Center draggableObject in draggableContainer on load
                gsap.set("#draggableObject", {xPercent: -20, yPercent: 0});
                
      
            }
        });
    }

    destroy() {
        // Destroy your module here
        app.$destroy();
    }
}